<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="summitSearch()">
                    <date-picker
                        :format="changeFormat"
                        :lang="lang"
                        confirm
                        placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                        range
                        type="date"
                        v-model="search.date">
                    </date-picker>
                    &nbsp;
                    <input class="form-control mr-sm-2"
                           placeholder="เลขที่ใบกำกับภาษี"
                           type="text"
                           v-model="search.tax_number"/>
                    <input class="form-control mr-sm-2"
                           placeholder="ค้นหา TN"
                           type="text"
                           v-model="search.invoice"/>
                    <multiselect
                        :customLabel="customerWithLabel"
                        :options="optionCustomer"
                        :show-labels="false"
                        class="form-control border-0"
                        placeholder="ค้นหาลูกค้า"
                        track-by="id"
                        v-model="search.customer">
                    </multiselect>
                    <b-form-select class="pr-4"
                                    :options="print_type"
                                    v-model="search.type_tax">
                    </b-form-select>
                    &nbsp;&nbsp;
                    <button @click="summitSearch()"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;
                    <button @click="printMultiTaxInvoice('PDF')" class="btn btn-primary"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์ใบกำกับภาษี
                    </button>
                    &nbsp;
                    <button :disabled="checkbox_id.length < 1" @click="printMultiTax"
                            class="btn btn-info"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์ใบกำกับภาษีหลายใบ
                    </button>
                    &nbsp;
                    <button @click="printMultiTaxInvoice('Excel')" class="btn btn-info" type="button">
                        <icon name="file"></icon>
                        Export Excel
                    </button>
                    &nbsp;
                    <button :disabled="checkbox_id.length < 1" @click="showTaxReport"
                            class="btn btn-warning"
                            type="button">
                        <icon name="plus"></icon>
                        สร้างใบเสร็จ RE
                    </button>
                    &nbsp;
                    <button v-if="canViewSuperAdmin"
                            @click.once="showCloseTaxModal"
                            class="btn btn-warning"
                            type="button">
                        <icon name="plus"></icon>
                        ปิดงวดภาษี
                    </button>
                    &nbsp;
                    <button :disabled="checkbox_id.length < 1"
                            v-if="canViewSuperAdmin"
                            @click="multipleDelete"
                            class="btn btn-danger"
                            type="button">
                        <icon name="trash"></icon>
                        ลบหลายรายการ
                    </button>
                </form>
            </div>
            <br/>
        </nav>
        <div style="color: red">***หมายเหตุ บิลขายที่ยังไม่มีการชำระเงิน จะไม่สามารถสร้างใบเสร็จได้</div>
        <div style="color: blue">***ของประเภทห้องเย็น ไม่ต้องคิดภาษี ยกเว้นประเภทเฟรนฟราย</div>
        <div style="font-weight: bold;font-size: 20px; text-align: right; padding-right: 10px">
            ยอดรวมใบกำกับภาษี : {{ sumTaxTotal | currency }} บาท
        </div>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">
                        <input type="checkbox" v-if="search.customer" v-model="selectAll"/>
                    </th>
                    <th>ใบเสร็จ</th>
                    <th>วัน/เดือน/ปี</th>
                    <th>เลขที่ใบกำกับภาษี</th>
                    <th>เลขที่บิลขาย</th>
                    <th>เลขประจำตัวผู้เสียภาษี</th>
                    <th>ชื่อลูกค้า</th>
                    <th>มูลค่าสินค้า</th>
                    <th>จำนวนเงินภาษีมูลค่าเพิ่ม</th>
                    <th>สถานะปิดงวด</th>
                    <th>ที่อยู่ใบกำกับภาษี</th>
                    <th>ดูข้อมูล</th>
                    <th v-if="canViewSuperAdmin">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in taxInvoiceList">
                    <td>
                        <input :value="data" type="checkbox"
                               v-model="checkbox_id"/>
                    </td>
                    <td>
                        <template v-if="data.billing_r_e">
                            <icon name="check" color="green"></icon>
                        </template>
                        <template v-else>
                            <icon name="times" color="red"></icon>
                        </template>
                    </td>
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        {{ data.tax_invoice }}
                    </td>
                    <td>
                        <template v-if="data.invoice">
                            {{ data.invoice.invoice_id }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.invoice.customer.have_new_address == 2">
                            {{ show_address_tax(data) }}
                        </template>
                        <template v-else-if="data.invoice.customer.tax_number">
                            {{
                                data.invoice.customer.tax_number
                            }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.invoice && data.invoice.customer">
                            {{ data.invoice.customer.store_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        {{ data.total | currency }}
                    </td>
                    <td>
                        {{ data.tax | currency }}
                    </td>
                    <td>
                        {{ data.closed ? 'ปิดงวด' : '-' }}
                    </td>
                    <td>
                        <button :disabled="!data.tax_invoice"
                                @click="printTaxInvoiceById(index,data.id)"
                                class="btn btn-primary"
                                type="button">
                            <icon name="home"></icon>
                            เลือกที่อยู่
                        </button>
                    </td>
                    <td>
                        <button @click="editTaxInvoice(data.id)"
                                :disabled="data.closed && !canViewSuperAdmin"
                                class="btn btn-outline-primary" type="button">
                            <icon name="pencil-alt"></icon>
                            แก้ไขข้อมูล
                        </button>
                    </td>
                    <td v-if="canViewSuperAdmin">
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--delete-->
        <b-modal hide-footer hide-header ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    class="btn btn-success"
                    type="button">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                    class="btn btn-outline-secondary"
                    type="button">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <div v-if="taxInvoiceList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getTaxInvoice">
            </vue-pagination>
        </div>
        <br>
        <b-modal hide-footer hide-header ref="print_tax">
            <print-tax @submit="printTaxInvoice" :file-type="fileTypeExport">
            </print-tax>
        </b-modal>
        <b-modal hide-footer hide-header ref="delete_item">
            <delete-confirm-modal @submit="deleteTaxInvoice">
            </delete-confirm-modal>
        </b-modal>
        <b-modal hide-footer hide-header ref="loading" no-close-on-backdrop no-close-on-esc>
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-footer hide-header ref="close_tax">
            <div style="text-align: center;">
                <h4>ปิดงวดภาษีจ่าย</h4>
                <br/>
                <div class="row form-group">
                    <label class="col-sm-5 text-right">เดือนที่ปิด</label>
                    <div class="col-sm-6">
                        <date-picker v-model="close_date"
                                     :lang="lang"
                                     type="month"
                                     placeholder="เดือนที่ปิด"
                                     class="w-100"
                                     :format="changeFormatMonth"
                                     confirm>
                        </date-picker>
                    </div>
                </div>

                <button type="button"
                        class="btn btn-primary"
                        @click="closeTaxMonth"
                >ยืนยัน
                </button>
            </div>
        </b-modal>
        <b-modal hide-footer hide-header ref="merge_print_tax">
            <div style="text-align: center;">
                <h4>สร้างใบเสร็จจากใบกำกับภาษีหลายรายการ</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-6">
                        <input type="radio" value="1" id="1" v-model="merge_print"/>
                        <label for="1">รวมใบ</label>
                    </div>
                    <div class="col-6">
                        <input type="radio" value="2" id="2" v-model="merge_print"/>
                        <label for="2">แยกใบ</label>
                    </div>
                </div>

                <button type="button"
                        class="btn btn-success mr-5"
                        @click="createBillingRE"
                >ยืนยัน
                </button>
                <button type="button"
                        class="btn btn-secondary"
                        @click="hideTaxReport"
                >ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--       print_tax_modal -->
        <b-modal hide-footer hide-header ref="tax_modal_address">
            <div style="text-align: center;">
                <h4>เลือกที่อยู่ออกใบกำกับภาษี</h4>
                <b-col class="col-sm-6 row text-left" sm="12">
                    <b-col class="offset-sm-0 offset-1 col-lg-6  col-12">
                        <input id="paid_period_1" name="paid_period"
                               type="radio"
                               v-model="tax_address" value="0">
                        <label for="paid_period_1">&nbsp;เหมือนที่อยู่</label>
                    </b-col>
                    <b-col class="offset-sm-0 offset-1 col-lg-6  col-12">
                        <input id="paid_period_2" name="paid_period"
                               type="radio"
                               v-model="tax_address" value="1">
                        <label for="paid_period_2">&nbsp;ที่อยู่ใหม่ 1</label>
                    </b-col>
                </b-col>
                <b-col class="col-sm-6 row text-left" sm="12">
                    <b-col class="offset-sm-0 offset-1 col-lg-6  col-12">
                        <input id="paid_period_3" name="paid_period"
                               type="radio"
                               v-model="tax_address" value="2">
                        <label for="paid_period_3">&nbsp;ที่อยู่ใหม่ 2</label>
                    </b-col>
                    <b-col class="offset-sm-0 offset-1 col-lg-6  col-12">
                        <input id="paid_period_4" name="paid_period"
                               type="radio"
                               v-model="tax_address" value="3">
                        <label for="paid_period_4">&nbsp;ที่อยู่ใหม่ 3</label>
                    </b-col>
                </b-col>
                <br/>
                <button @click="printTaxAddress"
                        class="btn btn-success"
                        type="button">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideTaxAddModal"
                        class="btn btn-secondary"
                        type="button">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--        <pre class="alert-primary">{{checkbox_id}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import {domain} from "../../../util/Constants";
import moment from "moment";
import PrintTax from "./PrintTax";
import DatePicker from 'vue2-datepicker'
import ExportExcelModal from "./ExportExcelModal";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
import {canViewSuperAdmin} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    name: "tax-invoice-list",
    components: {
        Loading,
        DeleteConfirmModal,
        ExportExcelModal,
        PrintTax,
        Multiselect,
        VuePagination,
        DatePicker,
    },

    created() {
        this.domain = domain;
        this.$store.dispatch("TaxInvoice/setTaxInvoice");
        this.$store.dispatch("TaxInvoice/clearSearch");
        this.getCustomerAll();
    },
    data() {
        return {
            domain: "",
            fileTypeExport: 'PDF',
            delete_id: null,
            event_submit: false,
            optionCustomer: [],
            checkbox_id: [],
            status_loading: 1,
            index_tax: '',
            msg: '',
            page: 1,
            tax_address: '',
            tax_address_id: '',
            tax_customer_id: '',
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/' + year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            changeFormatMonth: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment);
                    return date ? moment(date).format('MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            close_date: '',
            merge_print: 1,
            print_type: [
                {value: 'all', text: "ทั้งหมด"},
                {value: 'V', text: "เฉพาะ V"},
                {value: 'S', text: "เฉพาะ S"},
            ],
        }
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            taxInvoiceList: state => {
                return state.TaxInvoice.TaxInvoiceList
            },
            search: state => {
                return state.TaxInvoice.search
            },
            dataPaginate: state => {
                return state.TaxInvoice.dataPaginate;
            },
        }),
        sumTaxTotal() {
            let total = 0;
            this.checkbox_id.forEach(data => {
                total += parseFloat(data.total);
            })
            return total;
        },
        selectAll: {
            get: function () {
                return this.taxInvoiceList ? this.checkbox_id.length >= this.taxInvoiceList.length : false;
            },
            set: function (value) {
                if (value) {
                    this.$store.dispatch("Billing/setSelectAll", true)
                    this.selectBillingAll();
                } else {
                    this.$store.dispatch("Billing/setSelectAll", false)
                    this.checkbox_id = [];
                }
            }
        }
    },
    methods: {
        show_address_tax(item){
            if (item.invoice.customer.display_address_tax == 1 && item.invoice.customer.address_tax_1.tax_number)
                return item.invoice.customer.address_tax_1.tax_number
            else if(item.invoice.customer.display_address_tax == 2 && item.invoice.customer.address_tax_2.tax_number)
                return item.invoice.customer.address_tax_2.tax_number
            else if(item.invoice.customer.display_address_tax == 3 && item.invoice.customer.address_tax_3.tax_number)
                return item.invoice.customer.address_tax_3.tax_number
            else
                return '-'
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomerDropdown").then(customers => {
                this.optionCustomer = customers;
            });
        },
        multipleDelete() {
            this.$refs.delete_item.show();
        },
        customerWithLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showCloseTaxModal() {
            this.$refs.close_tax.show();
        },
        hideCloseTaxModal() {
            this.$refs.close_tax.hide();
        },
        hideTaxAddModal() {
            this.$refs.tax_modal_address.hide();
            this.tax_address = '';
        },
        closeTaxMonth() {
            if (this.close_date)
                this.$store.dispatch('TaxInvoice/closeTaxInvoice', moment(this.close_date).format("YYYY-MM")).then(() => {
                    this.hideCloseTaxModal()
                    this.getTaxInvoice()
                });
            else
                alert('กรุณากรอกเดือนที่ต้องการ')
        },
        printTaxInvoiceById(i, id) {
            this.tax_address_id = id;
            this.index_tax = i;
            this.tax_customer_id = this.taxInvoiceList[i].invoice.customer_id;
            if (this.taxInvoiceList[i].invoice.customer.have_new_address == 0 || this.taxInvoiceList[i].invoice.customer.have_new_address == 1) {
                this.tax_address = 0;
            } else if (this.taxInvoiceList[i].invoice.customer.have_new_address == 2 && this.taxInvoiceList[i].invoice.customer.display_address_tax == 1) {
                this.tax_address = 1;
            } else if (this.taxInvoiceList[i].invoice.customer.have_new_address == 2 && this.taxInvoiceList[i].invoice.customer.display_address_tax == 2) {
                this.tax_address = 2;
            } else if (this.taxInvoiceList[i].invoice.customer.have_new_address == 2 && this.taxInvoiceList[i].invoice.customer.display_address_tax == 3) {
                this.tax_address = 3;
            }
            this.$refs.tax_modal_address.show();
        },
        printTaxAddress() {
            this.msg = 'กำลังเลือกข้อมูล กรณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            let data = {
                tax_address_id: this.tax_address_id,
                tax_address: this.tax_address,
                tax_customer_id: this.tax_customer_id
            }
            this.$store.dispatch('TaxInvoice/chageAddressTaxInvoice', data).then(() => {
                this.hideLoadingModal()
                this.getTaxInvoice()
            });
            // window.open(domain + '/tax-invoice-pdf-new?id=' + this.tax_address_id + '&new=' + this.tax_address + '&customer_id=' + this.tax_customer_id, '_blank');
            // this.hideTaxAddModal();
        },
        deleteTaxInvoice(value) {
            if (value) {
                this.showLoadingModal();
                if (!this.delete_id)
                    this.delete_id = this.checkbox_id.map(x => (x.id)).join()
                this.$store.dispatch("TaxInvoice/deleteTaxInvoice", this.delete_id).then(() => {
                    // alert('ลบรายการสำเร็จ');
                    this.checkbox_id = [];
                    this.delete_id = null;
                    this.getTaxInvoice();
                }).catch(() => {
                    alert('ลบรายการไม่สำเร็จ');
                })
            }
            this.hideDeleteModal();
        },
        getTaxInvoice() {
            this.page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.searchTaxInvoices(this.page);
            } else {
                this.$store.dispatch('TaxInvoice/setTaxInvoice', this.page).then(() => this.hideLoadingModal())
            }
        },
        summitSearch() {
            this.checkbox_id = [];
            this.searchTaxInvoices(1);
        },
        selectBillingAll() {
            this.msg = 'กำลังเลือกข้อมูล กรณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.date = [];
            }
            let data = {
                start_date,
                end_date,
                customer_id: this.search.customer ? this.search.customer.id : '',
                tax_number: this.search.tax_number,
                invoice_id: this.search.invoice
            };
            this.$store.dispatch("TaxInvoice/search", {
                page: 0,
                data: data
            }).then(res => {
                if (res.length > 0) {
                    this.checkbox_id = res;
                }
                this.hideLoadingModal();
            })
        },
        searchTaxInvoices(page) {
            this.msg = 'กำลังเลือกข้อมูล กรณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            this.event_submit = true;
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.date = [];
            }
            let data = {
                start_date,
                end_date,
                customer_id: this.search.customer ? this.search.customer.id : '',
                tax_number: this.search.tax_number,
                invoice_id: this.search.invoice,
                tax_type: this.search.type_tax
            };
            this.$store.dispatch("TaxInvoice/search", {
                page: page,
                data: data
            }).then(() => this.hideLoadingModal())
        },
        printMultiTaxInvoice(type) {
            if (this.checkbox_id.length > 0) {
                let id = [];
                this.checkbox_id.forEach(data => {
                    id.push(data.id);
                });
                let info = {
                    id: id
                };
                let data = $.param(info);
                window.open(
                    `${domain}/tax-invoice-all-pdf?${data}`,
                    '_blank'
                );
            } else {
                this.fileTypeExport = type;
                this.showPrintTaxInvoice();
            }
        },
        showPrintTaxInvoice() {
            this.$refs.print_tax.show();
        },
        printTaxInvoice(value) {
            if (value) {
                if (this.fileTypeExport == 'Excel'){
                    this.exportExcel(value)
                }
                else{
                    let data = $.param(value);
                    window.open(
                        `${domain}/get-tax-date-pdf?${data}`,
                        '_blank'
                    );
                }
            }
            this.$refs.print_tax.hide();
        },
        showTaxReport() {
            this.$refs.merge_print_tax.show();
        },
        hideTaxReport() {
            this.$refs.merge_print_tax.hide();
        },
        createBillingRE() {
            this.showLoadingModal();
            this.msg = 'กำลังโหลดข้อมูล';
            this.status_loading = 1;
            let details = [];
            let customer_id = "";
            let sale_id = "";
            let date = moment().format("YYYY-MM-DD");
            if (this.checkbox_id.length > 0) {
                if (this.checkbox_id[0].invoice) {
                    customer_id = this.checkbox_id[0].invoice.customer_id;
                    sale_id = this.checkbox_id[0].invoice.sale_id;
                }
                this.checkbox_id.forEach(data => {
                    if (data.invoice) {
                        let info = {
                            tax_invoice_id: data.id,
                            customer_id: data.invoice.customer_id,
                            sale_id: data.invoice.sale_id,
                        };
                        details.push(info);
                    }
                });
                if (details.length > 0) {
                    let data = {
                        customer_id: customer_id,
                        sale_id: sale_id,
                        date: date,
                        details: details,
                        merge_type: this.merge_print
                    };
                    this.$store.dispatch("BillingRE/saveBillingRE", {
                        id: "",
                        data: data
                    }).then(() => {
                        this.$router.push("/accounting/billing-RE");
                        this.$store.dispatch("BillingRE/getBillings")
                    })
                } else {
                    alert("กรุณาเลือกใบกำกับภาษีที่มีบิลขายชำระเงิน");
                }
            } else {
                alert("กรุณาเลือกภาษีที่ต้องการสร้าง RE");
            }
        },
        exportExcel(value) {
            value['gen'] = 'excel';
            value['range'] = 2;
            let data = $.param(value);
            window.open(
                `${domain}/get-tax-date-pdf?${data}`,
                '_blank'
            );
            // window.open(`${domain}/get-tax-date-pdf?gen=excel&range=2&start_date=${start_date}&end_date=${end_date}`);

            // let start_date = '';
            // let end_date = '';
            // if (this.search.date.length > 0 && this.search.date[0]) {
            //     start_date = moment(this.search.date[0]).format('YYYY-MM-DD');
            //     end_date = moment(this.search.date[1]).format('YYYY-MM-DD');
            // } else {
            //     this.search.date = [];
            // }
            // if (start_date) {
            //     window.open(`${domain}/get-tax-date-pdf?gen=excel&range=2&start_date=${start_date}&end_date=${end_date}`);
            // } else {
            //     alert('กรุณาเลือกวันที่ในการออกรายงาน Excel');
            // }
        },
        editTaxInvoice(id) {
            this.$store.dispatch("TaxInvoice/showTaxInvoice", id).then(() => {
                let route = this.$router.resolve("/accounting/tax-invoice-form");
                window.open(route.href, '_blank');
                // this.$router.push("/accounting/tax-invoice-form");
            });
        },
        printMultiTax() {
            if (this.checkbox_id.length > 0) {
                let id = [];
                this.checkbox_id.forEach(data => {
                    id.push(data.id);
                })
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = 'กำลังดาวโหลดเอกสาร กรุณารอสักครู่';
                this.$store.dispatch("TaxInvoice/printMultiTax", id.toString()).then(url => {
                    if (url) {
                        window.open(url);
                        this.hideLoadingModal();
                    } else {
                        // this.showLoadingModal();
                        this.status_loading = 3;
                        this.msg = 'ไม่มีเอกสารที่สามารถดาวโหลดได้';
                    }
                }).catch(() => {
                    // this.showLoadingModal();
                    this.status_loading = 3;
                    this.msg = 'ดาวโหลดเอกสารไม่สำเร็จ';
                });
            }
        }
    }
}
</script>

<style scoped>
.select {
    border: 0;
}

.border-left-0 {
    border-left: 0;
}
</style>
